import React from "react";
//import { Button, Container, Divider, Grid, Header, Image, Menu, Segment } from 'semantic-ui-react'
import { Container } from "semantic-ui-react";
import "./fomantic/dist/semantic.css";
import "./App.css";
import { Switch, Route } from "react-router-dom";

import { EmptyLoginInfo } from "./Utils/Login";
import DynamicAuthProvider from "./Components/DynamicAuthProvider";
import AuthInitializer from "./Components/AuthInitializer";
import Menu from "./Menu";
import Login from "./Pages/Login";
import Footer from "./Footer";
import Home from "./Pages/Home";
import ContactUs from "./Pages/ContactUs";
import StyleDemo from "./StyleDemo";
import LegacyFrame, { LegacyPageWrapper } from "./Components/LegacyFrame";
import PrivateRoute from "./Components/PrivateRoute";
import Campaign from "./Pages/Campaign";
import Wiki, { NewWiki } from "./Pages/Wiki";
import OidcCallback from "./Components/OidcCallback";
import SilentRenew from "./Components/SilentRenew";
import UserManagement from "./Pages/UserManagement";
import UserList from "./Pages/UserList";
import DBStats from "./Pages/DBStats";
import UserActivity from "./Pages/UserActivity";
import UserLogins from "./Pages/UserLogins";
import DecadeVEvent from "./Pages/DecadeVEvent";

export default function App() {
  const [loginInfo, setLoginInfo] = React.useState(EmptyLoginInfo());

  // OIDC will handle authentication state, so we don't need the old API call
  // The loginInfo will be set by the AuthInitializer component after successful authentication

  let mainContent = (
    <Switch>
      <PrivateRoute loginInfo={loginInfo} path="/mailinglists">
        <LegacyFrame route="/lists.php" loginInfo={loginInfo} />
      </PrivateRoute>
      <PrivateRoute loginInfo={loginInfo} path="/alumnidb">
        <LegacyFrame route="/alumnidb.php" loginInfo={loginInfo} />
      </PrivateRoute>
      <PrivateRoute loginInfo={loginInfo} path="/alumnidb.php">
        <LegacyPageWrapper loginInfo={loginInfo} />
      </PrivateRoute>
      <PrivateRoute loginInfo={loginInfo} path="/wiki.php">
        <LegacyPageWrapper loginInfo={loginInfo} />
      </PrivateRoute>
      <PrivateRoute loginInfo={loginInfo} path="/photos">
        <LegacyFrame route="/wiki.php?page=421" loginInfo={loginInfo} />
      </PrivateRoute>
      <PrivateRoute loginInfo={loginInfo} path="/newwiki">
        <NewWiki loginInfo={loginInfo} />
      </PrivateRoute>
      <PrivateRoute loginInfo={loginInfo} path="/wiki">
        <Wiki loginInfo={loginInfo} />
      </PrivateRoute>
      <PrivateRoute loginInfo={loginInfo} path="/wiki.php">
        <LegacyPageWrapper loginInfo={loginInfo} />
      </PrivateRoute>
      <PrivateRoute loginInfo={loginInfo} path="/ordering">
        <LegacyFrame route="/ordering.php" loginInfo={loginInfo} />
      </PrivateRoute>
      <PrivateRoute loginInfo={loginInfo} path="/unsubscribe.php">
        <LegacyPageWrapper loginInfo={loginInfo} />
      </PrivateRoute>
      <Route path="/contact">
        <ContactUs />
      </Route>
      <Route path="/2021campaign">
        <Campaign loginInfo={loginInfo} />
      </Route>
      <Route path="/callback">
        <OidcCallback setLoginInfo={setLoginInfo} />
      </Route>
      <Route path="/silent-renew">
        <SilentRenew />
      </Route>
      <Route path="/styles">
        <StyleDemo />
      </Route>
      <PrivateRoute loginInfo={loginInfo} path="/account">
        <LegacyFrame
          route="/useradmin.php?cmd=editmine"
          loginInfo={loginInfo}
        />
      </PrivateRoute>
      <PrivateRoute loginInfo={loginInfo} path="/myaccount">
        <UserManagement loginInfo={loginInfo} />
      </PrivateRoute>
      <PrivateRoute loginInfo={loginInfo} path="/users/create">
        <UserManagement loginInfo={loginInfo} />
      </PrivateRoute>
      <PrivateRoute loginInfo={loginInfo} path="/users/activity">
        <UserActivity />
      </PrivateRoute>
      <PrivateRoute loginInfo={loginInfo} path="/users/logins">
        <UserLogins />
      </PrivateRoute>
      <PrivateRoute loginInfo={loginInfo} path="/users/db-stats">
        <DBStats />
      </PrivateRoute>
      <PrivateRoute loginInfo={loginInfo} path="/users/:id/edit">
        <UserManagement loginInfo={loginInfo} />
      </PrivateRoute>
      <PrivateRoute loginInfo={loginInfo} path="/users/:id">
        <UserManagement loginInfo={loginInfo} />
      </PrivateRoute>
      <PrivateRoute loginInfo={loginInfo} path="/users">
        <UserList loginInfo={loginInfo} />
      </PrivateRoute>
      <PrivateRoute loginInfo={loginInfo} path="/news/new">
        <LegacyFrame route="/news.php?cmd=addnews" loginInfo={loginInfo} />
      </PrivateRoute>
      <PrivateRoute loginInfo={loginInfo} path="/news/history">
        <LegacyFrame route="/news.php?cmd=archive" loginInfo={loginInfo} />
      </PrivateRoute>
      <PrivateRoute loginInfo={loginInfo} path="/decade-v">
        <DecadeVEvent />
      </PrivateRoute>
      {/*  bare "/" must always be the last path, since matching is by prefix */}
      <Route path="/">
        {loginInfo.id ? <Home loginInfo={loginInfo} /> : <Login setLoginInfo={setLoginInfo} />}
      </Route>
    </Switch>
  );

  return (
    <DynamicAuthProvider>
      <AuthInitializer setLoginInfo={setLoginInfo}>
        <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
          <Menu loginInfo={loginInfo} setLoginInfo={setLoginInfo} />
          <Container style={{ flex: 1 }}>
            {mainContent}
          </Container>
          <Footer />
        </div>
      </AuthInitializer>
    </DynamicAuthProvider>
  );
}
